export const ValidarStock = (entrada, form, reportes) => {
  let stock = 0;
  if (entrada["stock"] > 0 && entrada["stock"]) {
    stock = entrada["stock"];
    reportes.map((reporte) => {
      if (entrada["id"] == reporte.entradas_id) {
        let cantidad = reporte.cantidad;
        if (reporte.multiplicador && reporte.multiplicador !== 0) {
          cantidad = reporte.cantidad * reporte.multiplicador;
        }
        stock = stock - cantidad;
      }
    });
  } else {
    stock = form.stock;
    reportes.map((reporte) => {
      if (reporte.fecha == form.fecha + " HORA: " + form.hora) {
        let cantidad = reporte.cantidad;
        if (reporte.multiplicador && reporte.multiplicador !== 0) {
          cantidad = reporte.cantidad * reporte.multiplicador;
        }
        stock = stock - cantidad;
      }
    });
  }

  if (stock <= 0) {
    return false;
  }

  return true;
};
